import { useState, useEffect, useRef } from 'react';
import { copyToClipboard } from '../../../../utils/clipboard';
import type { PixPaymentViewProps } from '../types/pix-payment.types';

export const usePixPayment = (props: PixPaymentViewProps) => {
  const [emvCopied, setEmvCopied] = useState(false);
  const hasNotified = useRef(false);

  const handleCopyEmv = async () => {
    const emv = String(props.paymentDetails.emv || '').trim();
    if (!emv) {
      alert('Código PIX indisponível no momento. Abra o checkout do provedor para concluir o pagamento.');
      return;
    }
    const success = await copyToClipboard(emv);
    if (success) {
      setEmvCopied(true);
      setTimeout(() => setEmvCopied(false), 2000);
    } else {
      alert('Falha ao copiar o código PIX. Por favor, tente manualmente.');
    }
  };

  // Notificar venda para Shopify se os dados estiverem disponíveis (apenas uma vez)
  useEffect(() => {
    if (props.shopifyData && !hasNotified.current) {
      hasNotified.current = true;
      // Comentado para evitar duplicação - sistema unificado já cria o pedido
      // notifySaleToBackend(props.shopifyData);
    }
  }, [props.shopifyData]);

  return {
    emvCopied,
    handleCopyEmv,
  };
}; 